import { TransactionStatus } from "generated/graphql"
import { arrayToMap } from "utils/custom.utils"

export const BELONGS_TO = [
  {
    id: "vesatogo",
    name: "vesatogo",
  },
  {
    id: "farmsetu",
    name: "farmsetu",
  },
]
// Editing these items may break consistency with the server
export const ACCEPTANCE_CRITERIAS_MAP = {
  ACCP: "Accepted",
  ACCD: "Accepted under deviation",
  RJCT: "Rejected",
} as const

export const ACCEPTANCE_CRITERIAS = Object.keys(ACCEPTANCE_CRITERIAS_MAP).map(
  key => ({
    id: key,
    name: ACCEPTANCE_CRITERIAS_MAP[key],
  })
)

export const BAUD_RATES = [
  { name: "110", id: 110 },
  { name: "300", id: 300 },
  { name: "1200", id: 1200 },
  { name: "2400", id: 2400 },
  { name: "4800", id: 4800 },
  { name: "9600", id: 9600 },
  { name: "14400", id: 14400 },
  { name: "19200", id: 19200 },
  { name: "38400", id: 38400 },
  { name: "57600", id: 57600 },
  { name: "115200", id: 115200 },
]
export const CURRENT_STOCK_UNITS = [
  {
    id: "unit",
    name: "Units",
  },
  {
    id: "percentage",
    name: "Percentage",
  },
]

export const PLOT_COMMODITY_STATUS = {
  NOT_READY_FOR_HARVEST: "NRD",
  READY_FOR_HARVEST: "RDY",
  HARVEST_IN_PROGRESS: "WIP",
  ON_HOLD: "HLD",
  HARVESTING_DONE: "CMP",
  SCHEDULED_FOR_HARVEST: "SCH",
  HOLD_FOR_ALERT_CHEMICAL: "HAC",
}

export const PLOT_STATUSES = [
  {
    name: "Not Ready for Harvest",
    id: "NRD",
    icon: "cross",
    intent: "danger",
  },
  { name: "Ready for Harvest", id: "RDY", icon: "tick", intent: "success" },
  {
    name: "Scheduled for Harvest",
    id: "SCH",
    icon: "known-vehicle",
    intent: "primary",
  },
  {
    name: "Harvest in Progress",
    id: "WIP",
    icon: "refresh",
    intent: "success",
  },
  { name: "On Hold", id: "HLD", icon: "ban-circle", intent: "warning" },
  { name: "Harvesting Done", id: "CMP", intent: "success", icon: "endorsed" },
]

export const DAY_INTERVALS = [
  {
    id: 7,
    name: "7 Days",
  },
  {
    id: 14,
    name: "14 Days",
  },
  {
    id: 30,
    name: "30 Days",
  },
  {
    id: 60,
    name: "60 Days",
  },
  {
    id: 90,
    name: "90 Days",
  },
  {
    id: 180,
    name: "180 Days",
  },
]
export const USER_STATUSES = [
  { id: "AV", name: "Verified", intent: "success" },
  { id: "NA", name: "Not Verified", intent: "danger" },
  { id: "BS", name: "Blocked", intent: "warning" },
  { id: "OL", name: "On Leave", intent: "primary" },
]
export const VEHICLE_STATUSES = [
  {
    id: "AV",
    name: "Available",
    image: "CompletedStatus",
  },
  {
    id: "NA",
    name: "Not Available",
    image: "NotStartedStatus",
  },
  {
    id: "BR",
    name: "Broken",
    image: "DiscardedStatus",
  },
  {
    id: "OT",
    name: "On Trip",
    image: "OnTripStatus",
  },
  {
    id: "RP",
    name: "Repairing",
    image: "PausedStatus",
  },
]
export const TripStatusMap = {
  OT: "On Trip",
  CP: "Completed",
  DS: "Discarded",
  NS: "Not Started",
  PS: "Paused",
  IL: "Idle",
}

export const TRIP_STATUSES = [
  { id: "CP", intent: "success", name: "Completed" },
  { id: "OT", intent: "primary", name: "On Trip" },
  { id: "DS", intent: "warning", name: "Cancelled" },
  { id: "NS", intent: "none", name: "Not Started" },
  { id: "PS", intent: "warning", name: "Incomplete" },
  { id: "IL", intent: "warning", name: "Idle" },
  { id: "ST", intent: "success", name: "Settled" },
]

export const VEHICLE_STATUSES_MAP = VEHICLE_STATUSES.reduce((prev, vs) => {
  prev[vs.id] = vs
  return prev
}, {})

export const BOURNE_BY = [
  {
    id: "COMP",
    name: "Company",
  },
  {
    id: "OTHR",
    name: "Other",
  },
]

export const TRANSACTION_TYPES = [
  {
    id: "CASH",
    name: "Cash",
  },
  {
    id: "NEFT",
    name: "NEFT",
  },
  {
    id: "RTGS",
    name: "RTGS",
  },
  {
    id: "UPIP",
    name: "UPI Payment",
  },
  {
    id: "CHEQ",
    name: "Cheque",
  },
]

export const CONTRACT_STATUSES = [
  {
    id: "AC",
    name: "Active",
  },
  {
    id: "IA",
    name: "In-Active",
  },
  {
    id: "EX",
    name: "Expired",
  },
  {
    id: "CM",
    name: "Completed",
  },
]

export const SELLER_TYPES = [
  { id: "FAR", category: "Wholesale", name: "Farmer" },
  { id: "TRD", category: "Wholesale", name: "Trader" },
  { id: "AGG", category: "Wholesale", name: "Aggregator" },
  { id: "WHL", category: "Wholesale", name: "Wholeseller" },
  { id: "VEN", category: "Retail", name: "Vendor" },
  { id: "RET", category: "Retail", name: "Retailer" },
  { id: "STV", category: "Retail", name: "Street Vndor" },
]

export const PRICING_DONE_ON = [
  { name: "SKU Type", id: "SKU" },
  { name: "UOM Type", id: "QTY" },
]

export const COLOURS = [
  {
    id: "#CD5C5C",
    name: "Indian Red",
  },
  {
    id: "#F08080",
    name: "Light Coral",
  },
  {
    id: "#FA8072",
    name: "Salmon",
  },
  {
    id: "#E9967A",
    name: "Dark Salmon",
  },
  {
    id: "#FFA07A",
    name: "Light Salmon",
  },
  {
    id: "#DC143C",
    name: "Crimson",
  },
  {
    id: "#FF0000",
    name: "Red",
  },
  {
    id: "#B22222",
    name: "Fire Brick",
  },
  {
    id: "#8B0000",
    name: "Dark Red",
  },
  {
    id: "#FFC0CB",
    name: "Pink",
  },
  {
    id: "#FFB6C1",
    name: "Light Pink",
  },
  {
    id: "#FF69B4",
    name: "Hot Pink",
  },
  {
    id: "#FF1493",
    name: "Deep Pink",
  },
  {
    id: "#C71585",
    name: "Medium Violet Red",
  },
  {
    id: "#DB7093",
    name: "Pale Violet Red",
  },
  {
    id: "#FF7F50",
    name: "Coral",
  },
  {
    id: "#FF6347",
    name: "Tomato",
  },
  {
    id: "#FF4500",
    name: "Orange Red",
  },
  {
    id: "#FF8C00",
    name: "Dark Orange",
  },
  {
    id: "#FFA500",
    name: "Orange",
  },
  {
    id: "#FFD700",
    name: "Gold",
  },

  {
    id: "#FFEFD5",
    name: "Papaya Whip",
  },
  {
    id: "#FFE4B5",
    name: "Moccasin",
  },
  {
    id: "#FFDAB9",
    name: "Peach Puff",
  },
  {
    id: "#EEE8AA",
    name: "Pale Goldenrod",
  },
  {
    id: "#F0E68C",
    name: "Khaki",
  },
  {
    id: "#BDB76B",
    name: "Dark Khaki",
  },
  {
    id: "#E6E6FA",
    name: "Lavender",
  },
  {
    id: "#D8BFD8",
    name: "Thistle",
  },
  {
    id: "#DDA0DD",
    name: "Plum",
  },
  {
    id: "#EE82EE",
    name: "Violet",
  },
  {
    id: "#DA70D6",
    name: "Orchid",
  },
  {
    id: "#FF00FF",
    name: "Fuchsia",
  },
  {
    id: "#BA55D3",
    name: "Medium Orchid",
  },
  {
    id: "#9370DB",
    name: "Medium Purple",
  },
  {
    id: "#9966CC",
    name: "Amethyst",
  },
  {
    id: "#8A2BE2",
    name: "Blue Violet",
  },
  {
    id: "#9400D3",
    name: "Dark Violet",
  },
  {
    id: "#9932CC",
    name: "Dark Orchid",
  },
  {
    id: "#8B008B",
    name: "Dark Magenta",
  },
  {
    id: "#800080",
    name: "Purple",
  },
  {
    id: "#4B0082",
    name: "Indigo",
  },
  {
    id: "#6A5ACD",
    name: "Slate Blue",
  },
  {
    id: "#483D8B",
    name: "Dark Slate Blue",
  },
  {
    id: "#7B68EE",
    name: "Medium Slate Blue",
  },
  {
    id: "#ADFF2F",
    name: "Green Yellow",
  },
  {
    id: "#7FFF00",
    name: "Chartreuse",
  },
  {
    id: "#7CFC00",
    name: "Lawn Green",
  },
  {
    id: "#00FF00",
    name: "Lime",
  },
  {
    id: "#32CD32",
    name: "Lime Green",
  },
  {
    id: "#98FB98",
    name: "Pale Green",
  },
  {
    id: "#90EE90",
    name: "Light Green",
  },
  {
    id: "#00FA9A",
    name: "Medium Spring Green",
  },
  {
    id: "#00FF7F",
    name: "Spring Green",
  },
  {
    id: "#3CB371",
    name: "Medium Sea Green",
  },
  {
    id: "#2E8B57",
    name: "Sea Green",
  },
  {
    id: "#228B22",
    name: "Forest Green",
  },
  {
    id: "#008000",
    name: "Green",
  },
  {
    id: "#006400",
    name: "Dark Green",
  },
  {
    id: "#9ACD32",
    name: "Yellow Green",
  },
  {
    id: "#6B8E23",
    name: "Olive Drab",
  },
  {
    id: "#808000",
    name: "Olive",
  },
  {
    id: "#556B2F",
    name: "Dark Olive Green",
  },
  {
    id: "#66CDAA",
    name: "Medium Aquamarine",
  },
  {
    id: "#8FBC8F",
    name: "Dark Sea Green",
  },
  {
    id: "#20B2AA",
    name: "Light Sea Green",
  },
  {
    id: "#008B8B",
    name: "Dark Cyan",
  },
  {
    id: "#008080",
    name: "Teal",
  },
  {
    id: "#00FFFF",
    name: "Aqua",
  },
  {
    id: "#E0FFFF",
    name: "Light Cyan",
  },
  {
    id: "#AFEEEE",
    name: "Pale Turquoise",
  },
  {
    id: "#7FFFD4",
    name: "Aquamarine",
  },
  {
    id: "#40E0D0",
    name: "Turquoise",
  },
  {
    id: "#48D1CC",
    name: "Medium Turquoise",
  },
  {
    id: "#00CED1",
    name: "Dark Turquoise",
  },
  {
    id: "#5F9EA0",
    name: "Cadet Blue",
  },
  {
    id: "#4682B4",
    name: "Steel Blue",
  },
  {
    id: "#B0C4DE",
    name: "Light Steel Blue",
  },
  {
    id: "#B0E0E6",
    name: "Powder Blue",
  },
  {
    id: "#ADD8E6",
    name: "Light Blue",
  },
  {
    id: "#87CEEB",
    name: "Sky Blue",
  },
  {
    id: "#87CEFA",
    name: "Light Sky Blue",
  },
  {
    id: "#00BFFF",
    name: "Deep Sky Blue",
  },
  {
    id: "#1E90FF",
    name: "Dodger Blue",
  },
  {
    id: "#6495ED",
    name: "Cornflower Blue",
  },
  {
    id: "#4169E1",
    name: "Royal Blue",
  },
  {
    id: "#0000FF",
    name: "Blue",
  },
  {
    id: "#0000CD",
    name: "Medium Blue",
  },
  {
    id: "#00008B",
    name: "Dark Blue",
  },
  {
    id: "#000080",
    name: "Navy",
  },
  {
    id: "#191970",
    name: "Midnight Blue",
  },
  {
    id: "#FFEBCD",
    name: "Blanched Almond",
  },
  {
    id: "#FFE4C4",
    name: "Bisque",
  },
  {
    id: "#FFDEAD",
    name: "Navajo White",
  },
  {
    id: "#F5DEB3",
    name: "Wheat",
  },
  {
    id: "#DEB887",
    name: "Burly Wood",
  },
  {
    id: "#D2B48C",
    name: "Tan",
  },
  {
    id: "#BC8F8F",
    name: "Rosy Brown",
  },
  {
    id: "#F4A460",
    name: "Sandy Brown",
  },
  {
    id: "#DAA520",
    name: "Goldenrod",
  },
  {
    id: "#B8860B",
    name: "Dark Goldenrod",
  },
  {
    id: "#CD853F",
    name: "Peru",
  },
  {
    id: "#D2691E",
    name: "Chocolate",
  },
  {
    id: "#8B4513",
    name: "Saddle Brown",
  },
  {
    id: "#A0522D",
    name: "Sienna",
  },
  {
    id: "#A52A2A",
    name: "Brown",
  },
  {
    id: "#800000",
    name: "Maroon",
  },
  {
    id: "#2F4F4F",
    name: "Dark Slate Gray",
  },
]

export const TRANSPORTATION_TYPES = [
  { name: "Refrigerated Type", id: "RF" },
  { name: "Normal Type", id: "NR" },
  { name: "Other Type", id: "OT" },
]

export const DELIVERY_STATUSES = [
  {
    name: "Not Started",
    id: "NST",
  },
  {
    name: "Despatched To Dc",
    id: "DTD",
  },
  {
    name: "Arrived At Dc",
    id: "AAD",
  },
  {
    name: "Out For Delivery",
    id: "OFD",
  },
  {
    name: "Ready For Pickup",
    id: "RFP",
  },
  {
    name: "Delivered",
    id: "DLV",
  },
  {
    name: "Undelivered",
    id: "UDL",
  },
]
export const deliveryStatusMap = arrayToMap(DELIVERY_STATUSES)

export const PAYMENT_STATUSES = [
  {
    name: "Pending",
    id: "PND",
  },
  {
    name: "Success",
    id: "SUC",
  },
  {
    name: "Failed",
    id: "FAL",
  },
  {
    name: "In Process",
    id: "INP",
  },
  {
    name: "Refunded",
    id: "RUF",
  },
]
export const paymentStatusMap = arrayToMap(PAYMENT_STATUSES)

export const PAYMENT_METHODS = [
  { id: "NFT", name: "National Electronic Funds Transfer (NEFT)" },
  { id: "RTG", name: "Real-Time Gross Settlement (RTGS)" },
  { id: "CHQ", type: "cheque", name: "Cheque" },
  { id: "DMD", type: "cheque", name: "Demand Draft (DD)" },
  { id: "UPI", type: "digital", name: "Universal Payments Interface (UPI)" },
  { id: "COD", type: "cash", name: "Cash on Delivery" },
  { id: "ONL", type: "digital", name: "Online Payment" },
  {
    id: "CDT",
    type: "digital",
    name: "Credit",
  },
  { id: "NSE", name: "Not Selected" },
]

export const ORDER_TRANSACTION_STATUS = [
  { id: "NST", name: "Not Started" },
  { id: "AUT", name: "Authorized" },
  { id: "CAP", name: "Captured" },
  { id: "REF", name: "Refunded" },
  { id: "FAL", name: "Failed" },
  { id: "STL", name: "Settled" },
]

export const DELIVERY_METHODS = [
  { name: "Delivery", id: "HMD" },
  { name: "Self Pickup", id: "SPK" },
]
export const GENDER_TYPES = [
  { id: "ML", name: "Male", enum: "MALE" },
  { id: "FM", name: "Female", enum: "FEMALE" },
]
export const EDUCATION_TYPES = [
  { id: "TN", name: "10th Pass", enum: "TENTH_PASS" },
  { id: "TW", name: "12th Pass", enum: "TWLTH_PASS" },
  { id: "NO", name: "No education", enum: "NO_EDUCATION" },
  { id: "BH", name: "Bachelor(s) Degree", enum: "BACHELORS" },
  { id: "MS", name: "Master(s) Degree", enum: "MASTERS" },
  { id: "PH", name: "PHD", enum: "DOCTORATE" },
]

export const EMPLOYMENT_TYPES = [
  { id: "IN_PLANT_TRAINEE", name: "In-plant trainee", enum: "" },
  { id: "TRAINEE", name: "Trainee" },
  { id: "ON_PROBATION", name: "On Probation" },
  { id: "ON_THE_ROLE", name: "On the role" },
  { id: "NAPS", name: "NAPS" },
]

export const AGGREGATE_TYPES = [
  { id: "MAX", name: "Maximum" },
  { id: "MIN", name: "Minimum" },
  { id: "AVG", name: "Average" },
  { id: "SUM", name: "Sum" },
  { id: "NON", name: "None" },
]

export const BENCHMARK_TYPES = [
  { id: "FRP", name: "Farmer Purchase" },
  { id: "WHP", name: "Wholesale Purchase" },
  { id: "RTP", name: "Retail Purchase" },
  { id: "CUS", name: "Customer Sale" },
  { id: "WHS", name: "Wholesale Sale" },
  { id: "RTS", name: "Retail Sale" },
]

export const SELLER_CATEGORIES = [
  { id: "VEN", name: "Vendor" },
  {
    id: "FAR",
    name: "Farmer",
  },
  { id: "TRD", name: "Trader" },
  { id: "AGG", name: "Aggregator" },
  { id: "RET", name: "Retailer" },
  { id: "WHL", name: "Wholeseller" },
  {
    id: "STV",
    name: "Street Vendor",
  },
]
export const BENCHMARK_CATEGORIES = [
  {
    id: "FRP|WHP|RTP",
    name: "Wholesale",
  },
  {
    id: "CUS|WHS|RTS",
    name: "Retail",
  },
]

export const TRANSACTION_STATUS = [
  {
    name: "Created",
    id: TransactionStatus.CRT,
  },
  {
    name: "Authorized",
    id: TransactionStatus.AUT,
  },
  {
    name: "Successful",
    id: TransactionStatus.SUC,
  },
  {
    name: "Refunded",
    id: TransactionStatus.REF,
  },
  {
    name: "Failed",
    id: TransactionStatus.FAL,
  },
  {
    name: "Reconciled",
    id: TransactionStatus.RCN,
  },
  {
    name: "Reconcile Failed",
    id: TransactionStatus.RCF,
  },
]

export const ESTIMATED_DELIVERY_DAYS = [
  {
    id: "0d",
    name: "0 Days",
  },
  {
    id: "1d",
    name: "1 Day",
  },
  {
    id: "2d",
    name: "2 Days",
  },
  {
    id: "3d",
    name: "3 Days",
  },
  {
    id: "4d",
    name: "4 Days",
  },
  {
    id: "5d",
    name: "5 Days",
  },
  {
    id: "6d",
    name: "6 Days",
  },
  {
    id: "7d",
    name: "7 Days",
  },
  {
    id: "8d",
    name: "8 Days",
  },
  {
    id: "9d",
    name: "9 Days",
  },
  {
    id: "10d",
    name: "10 Days",
  },
]

export const NOTIFICATION_KINDS = [
  {
    id: "sms",
    name: "SMS",
  },
  {
    id: "email",
    name: "E-mail",
  },
  {
    id: "push",
    name: "Push Notification",
  },
]
